import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import eadReadAction from './eadReadEnrollment.action.json'

const eadReadEnrollmentDefinition = defineReadAutoAction(eadReadAction, 'matricula')

export default eadReadEnrollmentDefinition
